import { render } from "./GameOverScreen.vue?vue&type=template&id=520b9916&scoped=true"
import script from "./GameOverScreen.vue?vue&type=script&lang=js"
export * from "./GameOverScreen.vue?vue&type=script&lang=js"

import "./GameOverScreen.vue?vue&type=style&index=0&id=520b9916&scoped=true&lang=css"

import exportComponent from "F:\\Programming_And_Stuff\\Programming\\VueJs\\hangman\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520b9916"]])

export default __exports__